import type { PaginatedResponse } from "@/features/profiles/services/profiles/types";
import type { ReceivableDocument } from "./receivable-document.types";
import type { ReceivableTax } from "./receivable-tax.types";

export enum ReceivableCurrency {
  BRL = "BRL",
  USD = "USD",
}

export enum ReceivableStatus {
  WAITING = "WAITING",
  RECEIVED = "RECEIVED",
  CONCLUDED = "CONCLUDED",
  CALCULATING = "CALCULATING",
  CALCULATED = "CALCULATED",
  FAIL = "FAIL",
}

export enum ReceivableStore {
  APPLE = "APPLE",
  GOOGLE = "GOOGLE",
  STRIPE = "STRIPE",
}

export interface Receivable {
  id: string; // uuid
  currency: ReceivableCurrency;
  status: ReceivableStatus;
  store: ReceivableStore;
  grossValue: number; // valor bruto
  receivedValue?: number; // valor líquido (calculado) - somente resposta
  documents?: ReceivableDocument[];
  taxes?: ReceivableTax[];
  relatedDate: string; // YYYY-MM-DD (mês de referência)
  paidDate?: string; // YYYY-MM-DD (mês/diade pagamento)
  receivableShareConfigId?: string; // compatibilidade legado
  receivableShareConfig?: {
    id: string;
    name?: string | null;
  };
  createdBy?: string; // uuid
  updatedBy?: string; // uuid
  createdAt: string; // ISO datetime
  updatedAt: string; // ISO datetime
  file?: File;
}

export type ReceivableSortBy = 'relatedDate' | 'grossValue' | 'createdAt';
export type ReceivableOrder = 'asc' | 'desc';

export interface GetReceivablesParams {
  page?: number;
  limit?: number;
  status?: ReceivableStatus | 'all';
  currency?: ReceivableCurrency | 'all';
  store?: ReceivableStore | 'all';
  relatedDateStart?: string;
  relatedDateEnd?: string;
  paidDateStart?: string;
  paidDateEnd?: string;
  shareConfigId?: string;
  createdBy?: string;
  search?: string;
  sortBy?: ReceivableSortBy;
  order?: ReceivableOrder;
}

export type PaginatedReceivablesResponse = PaginatedResponse<Receivable>;

export interface CreateReceivablePayload {
  currency: ReceivableCurrency;
  status: ReceivableStatus;
  store: ReceivableStore;
  grossValue: number;
  relatedDate: string;
  paidDate?: string;
  receivableShareConfigId: string;
}

export interface UpdateReceivablePayload {
  currency?: ReceivableCurrency;
  status?: ReceivableStatus;
  store?: ReceivableStore;
  grossValue?: number;
  relatedDate?: string;
  paidDate?: string;
  receivableShareConfigId?: string | null;
}

